module.exports = __webpack_public_path__ + "img/tribunal.7b60e0ac.jpg";